<!--
 * @Author: jjchen
 * @Date: 2022-08-23 14:18:09
 * @LastEditors: jjchen
 * @LastEditTime: 2022-09-30 12:05:53
 * @Description: 
-->
<template>
  <div>
    <van-popup v-model="isShow" class="popup" @click-overlay="onClick">
      <div class="consult">
        <div class="consultHead">
          <div class="consultTitle">高新申报专家咨询通道</div>
          <svg-icon icon-class="gx-cancel" class="gx-cancel" @click="cancel"></svg-icon>
        </div>
        <div class="inputField">
          <van-field v-model="name" class="input" placeholder="请输入企业名称" />
          <van-field v-model="phoneNumber" class="input" placeholder="请输入联系电话" />
        </div>
        <van-button type="info" class="planFree" @click="getAdvisory" :loading="loading">免费获取专家方案</van-button>
        <div class="consultFooter">
          <div>
            今日有<span class="checkNum">{{ todayNum }}</span
            >人获取查询结果
          </div>
          <div>
            共计已有<span class="checkNum">{{ totalNum }}</span
            >次查询
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getAdvisoryApi, getStatisticsApi } from '@/api/enterpriseHighNewH5'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    companyName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      name: '',
      phoneNumber: '',
      todayNum: '', //今日获取结果数
      totalNum: '', //获取结果总数
      tempName: '', //保存第一次的公司名称
      loading: false,
      isShow: false,
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(val) {
        if (val) {
          this.isShow = val
          this.phoneNumber = JSON.parse(localStorage.getItem('userInfo')).username
          this.name = this.tempName
          this.getStatistics()
        }
      },
    },
    companyName(val) {
      if (val) {
        this.tempName = val
        this.name = val
      }
    },
  },
  mounted() {
    this.getStatistics()
    this.phoneNumber = JSON.parse(localStorage.getItem('userInfo')).username
  },
  methods: {
    onClick() {
      this.isShow = false
      this.$emit('update:show', false)
    },
    cancel() {
      this.isShow = false
      this.$emit('update:show', false)
    },
    async getAdvisory() {
      if (!this.name) {
        this.$toast('请输入企业名称')
        return
      }
      if (!this.phoneNumber) {
        this.$toast('请输入联系电话')
        return
      }
      this.loading = true
      const res = await getAdvisoryApi({
        companyName: this.name,
        phone: this.phoneNumber,
      })
      if (res.code == 0) {
        this.loading = false
        this.$toast('提交信息成功，已通知专家团队尽快联系，请耐心等待')
        this.isShow = false
        this.$emit('update:show', false)
        this.$emit('changeMask')
      } else {
        this.loading = false
        this.$toast(res.message)
      }
    },
    async getStatistics() {
      const res = await getStatisticsApi()
      if (res.code == 0) {
        this.todayNum = res.data.todayQueryCount
        this.totalNum = res.data.allQueryCount
      }
    },
  },
}
</script>
<style lang="less" scoped>
.popup {
  border-radius: 0.3rem;
  .consult {
    width: 5.4rem;
    height: 5.9rem;
    .consultHead {
      height: 1.46rem;
      position: relative;
      .consultTitle {
        font-size: 0.36rem;
        font-weight: 500;
        position: absolute;
        top: 0.5rem;
        left: 0.9rem;
      }
      .gx-cancel {
        width: 0.36rem;
        height: 0.36rem;
        position: absolute;
        top: 0.3rem;
        right: 0.3rem;
        cursor: pointer;
      }
    }

    .inputField {
      .input {
        width: 4.6rem;
        //   height: 0.7rem;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        margin: 0 auto 0.24rem auto;
      }
      /deep/ .van-cell {
        padding: 0.09rem 0.16rem;
      }
    }
    .planFree {
      width: 4.6rem;
      height: 0.7rem;
      border-radius: 4px;
      background: #356eff;
      font-size: 0.28rem;
      font-weight: 500;
      margin: 0.4rem auto 0.5rem auto;
      display: flex;
      justify-content: center;
    }
    .consultFooter {
      height: 1.2rem;
      background: #f7f7f7;
      border-radius: 0px 0px 0.3rem 0.3rem;
      font-size: 0.26rem;
      padding: 0.2rem 0;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .checkNum {
        color: #ff6d33;
      }
    }
  }
}
</style>
